import { memo } from "react";

import AppResourceArrayWrapperDto from "dto/components/pages/resources/app-resource-array-wrapper-dto";

import AppButton from "components/app-button";

const AppResourceArrayWrapper = ({ children, title, onAdd, onUpdate, error, disabled }: AppResourceArrayWrapperDto) => {
	return (
		<div className="app-resource-array-wrapper">
			<div className="array-wrapper">
				<p className="array-wrapper__title">{title}</p>

				<div className="array-wrapper__content">
					<div className="array-wrapper__header">
						<p className="array-wrapper__header-text">* Please click on update button to save your progress under this section.</p>

						{onAdd && <AppButton type="button" label="Add" outline onClick={onAdd} disabled={disabled} />}
					</div>
					
					{error && <p className="array-wrapper__header-text">{error}</p>}

					{children}

					<div className="array-wrapper__cta">
						<AppButton type="button" label="Update" outline onClick={onUpdate} />
					</div>
				</div>
			</div>
		</div>
	);
};

export default memo(AppResourceArrayWrapper);
